import { z } from 'zod/v4-mini';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
export const ZodPackageUpdatePayload = matchingZodObject({
    packageName: z.string(),
    version: z.string(),
    entryPoints: z.array(z.object({
        importPath: z.string(),
        bundleUrl: z.string(),
    })),
});
//# sourceMappingURL=PackageUpdatePayload.js.map